<template>
  <div id="super-admin-center-base" class="flex">
    <div class="flex flex-col flex-grow">
      <div
        class="sticky top-0 left-0 z-50 flex items-center flex-shrink-0 h-10 px-6 border-b border-slate-400 bg-pure-white"
        :style="{ width: 'calc(100vw - 0.5rem)' }"
      >
        <BlBreadcrumbs :breadcrumbs="breadcrumbs" />
      </div>

      <div class="flex">
        <div
          id="super-admin-center-tabs"
          class="sticky left-0 z-40 flex-shrink-0 overflow-y-auto border-r top-10 w-60 bg-pure-white border-slate-400"
          :style="{ height: 'calc(100vh - 3.25rem)' }"
        >
          <div class="flex flex-col py-6 pl-6">
            <router-link
              v-for="tab in tabs"
              :key="tab.target"
              :to="tab.target"
              class="relative flex items-center justify-between h-12 gap-3 transition-all duration-300 border-b rounded border-slate-400"
            >
              <BlTextSubtitle3
                :text="tab.label"
                :class="[tab.isActive ? 'text-light-purple' : 'text-slate-700']"
              />
              <div
                class="flex-shrink-0 w-1 h-12"
                :class="[tab.isActive ? 'bg-light-purple' : 'bg-pure-white']"
              ></div>
            </router-link>
          </div>
        </div>

        <div v-if="pageLoading" class="grid w-full h-128 place-items-center">
          <div class="blum-loader"></div>
        </div>
        <div
          v-else
          id="super-admin-center-body"
          class="flex flex-col flex-grow"
        >
          <CenterInformation v-if="!this.$route.params.tab" />
          <CenterSubscription
            v-if="this.$route.params.tab === 'subscription'"
          />
          <CenterTeam v-if="this.$route.params.tab === 'team'" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import CenterInformation from "./CenterInformation.vue";
import CenterSubscription from "./CenterSubscription.vue";
import CenterTeam from "./CenterTeam.vue";

import BlTextSubtitle3 from "../../BlTextSubtitle3.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlBreadcrumbs from "../../BlBreadcrumbs.vue";
import BlIcon from "../../BlIcon.vue";

export default {
  name: "SuperAdminCenter",
  components: {
    CenterInformation,
    CenterSubscription,
    CenterTeam,
    BlTextSubtitle3,
    BlTextBody2,
    BlBreadcrumbs,
    BlIcon
  },
  data() {
    return {
      pageLoading: true
    };
  },
  computed: {
    ...mapGetters(["currentUser", "center"]),
    breadcrumbs() {
      const centerId = Number(this.$route.params.id);
      const centerLabel =
        (this.center && this.center.id) !== centerId
          ? "Center name"
          : this.center.name;
      return [
        { label: "Centers management", target: `/super-admin` },
        {
          label: centerLabel,
          target: `/super-admin/center/${centerId}`,
          truncate: true
        }
      ];
    },
    tabs() {
      const centerId = Number(this.$route.params.id);
      return [
        {
          target: `/super-admin/center/${centerId}`,
          isActive: !this.$route.params.tab,
          label: "Center information"
        },
        {
          target: `/super-admin/center/${centerId}/subscription`,
          isActive: this.$route.params.tab === "subscription",
          label: "Subscription"
        },
        {
          target: `/super-admin/center/${centerId}/team`,
          isActive: this.$route.params.tab === "team",
          label: "Team"
        }
      ];
    }
  },
  async mounted() {
    if (this.currentUser.role !== "super_admin") {
      return this.$router.push({ name: "Clients" });
    }

    this.pageLoading = true;
    const centerId = Number(this.$route.params.id);
    await this.getCenter({ id: centerId });
    this.pageLoading = false;
  },
  destroyed() {
    const app = document.getElementById("app");
    if (app) app.scroll({ top: 0, left: 0 });
  },
  methods: {
    ...mapActions(["getCenter"])
  }
};
</script>



// WEBPACK FOOTER //
// src/components/superAdmin/center/Center.vue